import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AddressCardComponent } from '../../../../../../misc/address-card/address-card.component';
import { ModalService } from '../../../../../../../../components/modal-list/modal-list.service';
import { Address, I18nModule } from '@spartacus/core';

@Component({
  selector: 'modal-address-confirmation',
  standalone: true,
  imports: [CommonModule, AddressCardComponent, I18nModule],
  templateUrl: './modal-address-confirmation.component.html',
  styleUrl: './modal-address-confirmation.component.scss',
})
export class ModalAddressConfirmationComponent {
  @Input() data!: {
    address: Address;
    next: Function;
  };

  constructor(private modalService: ModalService) {}

  cancel() {
    this.modalService.close();
  }

  next() {
    this.cancel();
    this.data.next();
  }
}
